const workerCode = `
  let _index = [];

  self.onmessage = function(e) {
    const { type, payload } = e.data;

    if (type === 'BUILD_INDEX') {
      _index = payload.nodes;
      self.postMessage({ type: 'INDEX_READY' });
    }

    if (type === 'SEARCH') {
      const q = payload.query.toLowerCase();
      const results = [];

      _index.forEach((entry) => {
        const lower = entry.text.toLowerCase();
        let idx = lower.indexOf(q);
        while (idx !== -1) {
          results.push({
            nodeId: entry.nodeId,
            start: idx,
            end: idx + q.length,
          });
          idx = lower.indexOf(q, idx + 1);
        }
      });

      self.postMessage({ type: 'SEARCH_RESULTS', results });
    }
  };
`;

export function createSearchWorker() {
  const blob = new Blob([workerCode], { type: 'application/javascript' });
  const url = URL.createObjectURL(blob);
  const worker = new Worker(url);
  worker._blobUrl = url;
  return worker;
}